import Head from 'next/head';

const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, '') ||
  'https://vitaleducators.com';

const DEFAULT_IMAGE = '/hero/homehero.jpg';
const DEFAULT_SITE_NAME = 'Vital Educators';

type SeoHeadProps = {
  title: string;
  description: string;
  path?: string;
  image?: string;
};

const getAbsoluteUrl = (value: string) => {
  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  return `${SITE_URL}${value.startsWith('/') ? value : `/${value}`}`;
};

export default function SeoHead({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
}: SeoHeadProps) {
  const url = getAbsoluteUrl(path);
  const imageUrl = getAbsoluteUrl(image);

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="msvalidate.01" content="CEC9C25190E260ED9833E286D1C53A32" />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={DEFAULT_SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@VitalEducators" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Head>
  );
}
